import { COMMERCIAL_STATUS_MAX_LENGTH, pesIconSizes } from '@pes-ui/utils';
import { h } from '@stencil/core';
import { isBrowser } from '../../../../globals/utils';
export const CommercialMessage = ({ backgroundColor, color, message, }) => {
  return (h("div", { style: { backgroundColor, color }, class: "product-status", title: message }, isBrowser() && h("pes-icon", { size: pesIconSizes.MICRO }, "notification_critical_stroke"), "\u00A0", h("pes-ellipsis", { class: "product-status__label", content: message, maxLength: COMMERCIAL_STATUS_MAX_LENGTH })));
};
